import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZipFolderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 17,
	viewBox: "0 0 22 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 0H2.125C0.95625 0 0.010625 0.95625 0.010625 2.125L0 14.875C0 16.0438 0.95625 17 2.125 17H19.125C20.2938 17 21.25 16.0438 21.25 14.875V4.25C21.25 3.08125 20.2938 2.125 19.125 2.125H10.625L8.5 0Z",
			fill: "url(#paint0_linear_258_6417)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7568 13.9458V14.875H6.03622V13.9458H10.7568ZM10.6494 8.80038L6.47046 14.875H5.68604V14.1326L9.87897 8.07666H10.6494V8.80038ZM10.2151 8.07666V9.0105H5.71405V8.07666H10.2151Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1854 8.07666V14.875H12.0134V8.07666H13.1854Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3836 12.3396H15.614V11.4105H17.3836C17.6918 11.4105 17.9408 11.3607 18.1307 11.261C18.3206 11.1614 18.4591 11.0245 18.5462 10.8502C18.6365 10.6727 18.6816 10.4704 18.6816 10.2432C18.6816 10.0284 18.6365 9.82761 18.5462 9.64084C18.4591 9.45096 18.3206 9.29843 18.1307 9.18326C17.9408 9.06808 17.6918 9.0105 17.3836 9.0105H15.9735V14.875H14.8015V8.07666H17.3836C17.9097 8.07666 18.3563 8.17004 18.7237 8.35681C19.0941 8.54047 19.3758 8.79572 19.5688 9.12256C19.7618 9.44629 19.8583 9.81671 19.8583 10.2338C19.8583 10.6727 19.7618 11.0494 19.5688 11.3638C19.3758 11.6782 19.0941 11.9194 18.7237 12.0875C18.3563 12.2556 17.9097 12.3396 17.3836 12.3396Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_258_6417",
			x1: 10.625,
			y1: 0,
			x2: 10.625,
			y2: 17,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E03539" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E1373B"
			})]
		}) })
	]
});
export default SvgZipFolderIcon;
